import { PageLink, PageTitle } from "@common-metronic/layout/core"
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom"
import CandidatsRecherche from "./candidats/recherche/CandidatsRecherche"
import AnnonceCreate from "./annonces/create/AnnonceCreate"
import LogsSearchCandidate from "./candidats/recherche/logsAndSavedFiltersSearchCandidate/logs/LogsSearchCandidate"
import SavedFiltersSearchCandidate from "./candidats/recherche/logsAndSavedFiltersSearchCandidate/savedFilters/SavedFiltersSearchCandidate"
import CandidatsRechercheResults from "./candidats/recherche/results/CandidatsRechercheResults"
import DemandeEmbaucheDetails from "./demandesEmbauche/details/DemandeEmbaucheDetails"
import DemandesEmbaucheListing from "./demandesEmbauche/listing/DemandesEmbaucheListing"
import AnnoncesListing from "./annonces/listing/AnnoncesListing"
import AnnonceActivation from "./annonces/enable/AnnonceActivation"
import ViviersListing from "./viviers/listing/ViviersListing"
import VivierCreate from "./viviers/create/VivierCreate"
import CandidatImport from "./candidats/import/CandidatImport"
import DemandeEmbaucheStart from "./demandesEmbauche/start/DemandeEmbaucheStart"
import AnnonceCloneAction from "./annonces/clone/AnnonceClone"
import GlobalHelper from "@common-helpers/GlobalHelper"
import CandidatCreate from "./candidats/create/CandidatCreate"

const RecrutementRouting = () => {
     const location = useLocation()
     const params = new URLSearchParams(location.search)
     const vivier_id = params.get("vivier_id")
     const vivier_name = params.get("vivier_name")
     const liste_traitement = params.get("areCandidatesInListeDeTraitement")
     const annonce_title = params.get("annonce_title")

     const candidatsBreadCrumbs: Array<PageLink> = [
          { title: "Recrutement" },
          {
               title: "Candidats",
               path: "/recrutement/candidats/search",
          },
     ]

     const viviersBreadCrumbs: Array<PageLink> = [
          { title: "Recrutement" },
          {
               title: "Viviers",
               path: "/recrutement/viviers/listing",
          },
     ]

     const candidatsRechercheBreadCrumbs: Array<PageLink> = [
          ...candidatsBreadCrumbs,
          {
               title: "Recherche",
               path: "/recrutement/candidats/search",
          },
     ]

     const candidatsRechercheResultatsBreadCrumbs: Array<PageLink> = (() => {
          if (vivier_name && vivier_id) {
               return [
                    ...viviersBreadCrumbs,
                    {
                         title: GlobalHelper.firstLetterUppercase(vivier_name),
                    },
                    {
                         title: "Candidats",
                    },
               ]
          }

          if (liste_traitement) {
               return [
                    ...candidatsBreadCrumbs,
                    {
                         title: "Liste de traitement",
                    },
               ]
          }

          return [
               ...candidatsBreadCrumbs,
               {
                    title: "Recherche",
                    path: "/recrutement/candidats/search",
               },
               { title: "Résultats" },
          ]
     })()

     const annoncesBreadCrumbs: Array<PageLink> = [
          { title: "Recrutement" },
          {
               title: "Annonces",
               path: "/recrutement/annonces/listing",
          },
     ]

     const annonceCandidaturesBreadCrumbs: Array<PageLink> = [...annoncesBreadCrumbs, { title: annonce_title || "" }]

     const demandesEmbaucheBreadCrumbs: Array<PageLink> = [
          { title: "Recrutement" },
          {
               title: "Demandes d'embauche",
               path: "/recrutement/demandes-embauche/listing",
          },
     ]

     return (
          <Routes>
               <Route
                    element={
                         <>
                              <Outlet />
                         </>
                    }
               >
                    <Route
                         path="/annonces"
                         element={
                              <>
                                   <Outlet />
                              </>
                         }
                    >
                         <Route path=":annonce_id/clone" element={<AnnonceCloneAction />} />

                         <Route
                              path="listing"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={annoncesBreadCrumbs}>Listing</PageTitle>
                                        <AnnoncesListing />
                                   </>
                              }
                         />
                         <Route
                              path="create"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={annoncesBreadCrumbs}>Création</PageTitle>
                                        <AnnonceCreate />
                                   </>
                              }
                         />
                         <Route
                              path="activation"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={annoncesBreadCrumbs}>Activation</PageTitle>
                                        <AnnonceActivation />
                                   </>
                              }
                         />

                         <Route
                              path="candidatures"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={annonceCandidaturesBreadCrumbs}>Candidatures</PageTitle>
                                        <CandidatsRechercheResults />
                                   </>
                              }
                         />

                         <Route
                              path="candidatures-not-seen"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={annonceCandidaturesBreadCrumbs}>Candidatures non consultées</PageTitle>
                                        <CandidatsRechercheResults />
                                   </>
                              }
                         />
                    </Route>

                    <Route
                         path="/candidats"
                         element={
                              <>
                                   <Outlet />
                              </>
                         }
                    >
                         <Route
                              path="import"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={candidatsBreadCrumbs}>Ajouter</PageTitle>
                                        <CandidatImport />
                                   </>
                              }
                         />
                         <Route
                              path="create"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={candidatsBreadCrumbs}>Ajouter</PageTitle>
                                        <CandidatCreate />
                                   </>
                              }
                         />
                         <Route
                              path="search"
                              element={
                                   <>
                                        <Outlet />
                                   </>
                              }
                         >
                              <Route
                                   path=""
                                   element={
                                        <>
                                             <PageTitle breadcrumbs={candidatsBreadCrumbs}>Recherche</PageTitle>
                                             <CandidatsRecherche />
                                        </>
                                   }
                              />
                              <Route
                                   path="logs"
                                   element={
                                        <>
                                             <PageTitle breadcrumbs={candidatsRechercheBreadCrumbs}>Historique</PageTitle>
                                             <LogsSearchCandidate />
                                        </>
                                   }
                              />
                              <Route
                                   path="saved-filters"
                                   element={
                                        <>
                                             <PageTitle breadcrumbs={candidatsRechercheBreadCrumbs}>Filtres sauvegardés</PageTitle>
                                             <SavedFiltersSearchCandidate />
                                        </>
                                   }
                              />
                              <Route
                                   path="results"
                                   element={
                                        <>
                                             <PageTitle breadcrumbs={candidatsRechercheResultatsBreadCrumbs} />
                                             <CandidatsRechercheResults />
                                        </>
                                   }
                              />
                         </Route>
                    </Route>

                    <Route
                         path="/demandes-embauche"
                         element={
                              <>
                                   {/*<div>header</div>*/}
                                   <Outlet />
                              </>
                         }
                    >
                         <Route
                              path="listing"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={demandesEmbaucheBreadCrumbs}>Listing</PageTitle>
                                        <DemandesEmbaucheListing />
                                   </>
                              }
                         />
                         <Route
                              path="start"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={demandesEmbaucheBreadCrumbs}>Listing</PageTitle>
                                        <DemandeEmbaucheStart />
                                   </>
                              }
                         />
                         <Route
                              path=":consultant_id/details"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={demandesEmbaucheBreadCrumbs}>Détails</PageTitle>
                                        <DemandeEmbaucheDetails />
                                   </>
                              }
                         />
                    </Route>

                    <Route
                         path="/viviers"
                         element={
                              <>
                                   {/*<div>header</div>*/}
                                   <Outlet />
                              </>
                         }
                    >
                         <Route
                              path="listing"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={viviersBreadCrumbs}>Listing</PageTitle>
                                        <ViviersListing />
                                   </>
                              }
                         />
                         <Route
                              path="create"
                              element={
                                   <>
                                        <PageTitle breadcrumbs={viviersBreadCrumbs}>Création</PageTitle>
                                        <VivierCreate />
                                   </>
                              }
                         />
                    </Route>

                    {/*Default route*/}
                    <Route index element={<Navigate to="search" />} />
               </Route>
          </Routes>
     )
}

export default RecrutementRouting
